module.exports = __webpack_public_path__ + "img/SecondWarning.de1e8235.jpg";